<template>
	<div>
		<div class="font-20 font-weight-bold grey--text text--darken-1 mb-6">
			{{ $vuetify.lang.t('$vuetify.views.group.settings.header') }}
		</div>
		<v-tabs v-model="tab">
			<v-tab class="text-capitalize grey--text text--darken-2">
				{{ $vuetify.lang.t('$vuetify.views.group.settings.tabs.one.title') }}
			</v-tab>
			<v-tab class="text-capitalize grey--text text--darken-2">
				{{ $vuetify.lang.t('$vuetify.views.group.settings.tabs.two.title') }}
			</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item>
				<group-form class="pt-6" v-model="form" />
				<v-btn
					color="red lighten-1"
					class="red--text mt-8"
					elevation="0"
					@click="removeGroup({})"
				>
					<v-icon class="mr-1">$trash</v-icon>Usuń grupę
				</v-btn>
				<div class="d-flex justify-content-center mt-5">
					<div class="d-flex">
						<v-btn
							color="grey lighten-2"
							elevation="0"
							@click="leave()"
							:disabled="sending"
						>{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
						<v-btn
							class="ml-3"
							color="accent"
							elevation="0"
							@click="sendData()"
							:disabled="sending"
						>{{ $vuetify.lang.t('$vuetify.saveChanges') }}</v-btn>
					</div>
				</div>
			</v-tab-item>
			<v-tab-item>
				<group-form-switches :form="form" />
				<div class="d-flex justify-content-center mt-5">
					<div class="d-flex">
						<v-btn
							color="grey lighten-2"
							elevation="0"
							@click="leave()"
							:disabled="sending"
						>{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
						<v-btn
							class="ml-3"
							color="accent"
							elevation="0"
							@click="sendData()"
							:disabled="sending"
						>{{ $vuetify.lang.t('$vuetify.saveChanges') }}</v-btn>
					</div>
				</div>
				<group-form-members
					:form="form"
					:editable="true"
				/>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import GroupForm from "@/components/group/GroupForm";
import GroupFormSwitches from "@/components/group/GroupFormSwitches";
import {mapActions} from "vuex";
import GroupFormMembers from "@/components/group/GroupFormMembers";
export default {
	name: "GroupSettings",
	components: {
		GroupFormMembers,
		GroupForm,
		GroupFormSwitches
	},
	props: {
		group: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			tab: 0,
			form: null,
			sending: false
		}
	},
	created() {
		this.form = Object.assign({}, this.group)
	},
	methods: {
		...mapActions('groups', [
			'updateGroup',
			'removeGroup',
		]),
		...mapActions('files', {
			avatarUpload: 'upload'
		}),
		leave() {
			this.$emit('input', 'base')
		},
		async sendData() {
			this.sending = true
			let form = Object.assign({}, this.form)
			if (form.avatar && form.avatar.url && !form.avatar.id) {
				let avatarParams = {
						type: 'image',
						for: 'group_avatar',
						file: encodeURIComponent(form.avatar.url)
					},
					avatarResponse = (form.avatar.url) ? await this.avatarUpload(avatarParams) : null
				if (avatarResponse.success)
					form.avatar_token = avatarResponse.token
				else
					delete form.avatar_token
			}
			if (!form.avatar)
				delete form.avatar
			if (!form.avatar_token)
				delete form.avatar_token
			if (form.is_public)
				delete form.is_hide

			if (await this.updateGroup({ params : form })) {
				this.leave()
				this.$snackbar.success("Grupa została zaktualizowana!")
			}
			this.sending = false
		}
	}
}
</script>

<style scoped>

</style>
